<template>
  <div>
    <swiper :type="1"></swiper>
    <home-about></home-about>
    <home-brand></home-brand>
    <home-dynamic></home-dynamic>
  </div>
</template>
<script>
import swiper from "./swiper";
import homeAbout from "./home/homeAbout";
import homeBrand from "./home/homeBrand";
import homeDynamic from "./home/homeDynamic";

export default {
  components: {
    swiper,
    homeAbout,
    homeBrand,
    homeDynamic
  },
  data() {
    return {};
  },
  created() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      let config = this.$cache.get("slideConfig");
      if (config) {
        if (config.catalog.indexOf(1) !== -1) {
          this.swiperShow = true;
        }
      }
    }
  }
};
</script>
